import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getNotificationCounts = (
    backend: string,
    token: string,
    user: number
) => {
    return fetch(
        `${getApiUrl(backend)}notification_counts?user=${user}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getNotificationCounts;

